import { usePrimaryPage } from '@/PageManager'
import { switchFeed } from '@/atoms/feed'
import RelayIcon from '@/components/RelayIcon'
import { useResolvedHardcodedFeed } from '@/hooks/useResolvedHardcodedFeed'
import type { THardcodedFeed } from '@/types/window'
import SidebarItem from './SidebarItem'

export default function HardcodedFeedItem({
  item,
  index,
  collapse,
  active
}: {
  item: THardcodedFeed
  index: number
  collapse: boolean
  active: boolean
}) {
  const { navigate } = usePrimaryPage()
  const { name, icon } = useResolvedHardcodedFeed(item)

  return (
    <SidebarItem
      title={name}
      onClick={() => {
        navigate('home')
        switchFeed({ hardcodedFeed: index })
      }}
      active={active}
      collapse={collapse}
    >
      {icon ? (
        <img src={icon} className="w-5 h-5 object-cover object-center rounded" alt="" />
      ) : (
        <RelayIcon iconSize={16} />
      )}
    </SidebarItem>
  )
}
